<template>
  <div>
    <div class="mb-5">
      <h3 class="heading semi-bold">Bulk Pattern Upload</h3>
    </div>

    <div class="grid shadow bg-white mt-20" v-if="!isReadOnlyUser">
      <div class="grid-body">
        <h4>
          Please select files to upload. Only <strong>.pdf</strong> extensions
          files can be uploaded through this interface.
        </h4>

        <div class="btn btn-block btn-default mb">
          <input
            type="file"
            multiple
            @change="selectFile"
            :disabled="uploadInProgress"
            accept=".pdf"
          />
        </div>

        <button
          class="btn btn-success"
          :disabled="selectedFiles.length == 0 || uploadInProgress"
          @click="uploadFiles"
        >
          Upload
        </button>
      </div>
    </div>
    <div class="grid shadow bg-white mt-20" v-else>
      <div class="grid-body">
        <h4>
          You don't have the privilege to do this action, please contact an
          administrator.
        </h4>
      </div>
    </div>

    <div
      class="grid shadow bg-white mt-20"
      v-if="selectedFiles && !isReadOnlyUser"
    >
      <div class="grid-title">
        <h4 class="semi-bold">Selected Files ({{ selectedFiles.length }})</h4>
      </div>
      <div class="grid-body">
        <div
          class="well well-sm"
          v-for="(file, index) in selectedFiles"
          :key="index"
        >
          <span class="pb"
            ><strong>{{ file.name }}</strong> ({{
              _formatSizeUnits(file.size)
            }})</span
          >
          <div class="progress">
            <div
              class="progress-bar progress-bar-info"
              role="progressbar"
              :aria-valuenow="file.progress"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="{ width: file.progress + '%' }"
            >
              {{ file.progress }}%
            </div>
          </div>
          <button class="btn btn-sm btn-danger" @click="removeFile(index)">
            <span class="fa fa-close"></span> Remove
          </button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal"
      id="error-dialog"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">Error Details</h5>
          </div>
          <div class="modal-body bg-white">
            <div v-for="(file, index) in selectedFiles">
              <div v-if="file.errors !== ''">
                <strong>File: {{ file.name }}</strong
                ><br />
                {{ file.errors }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              @click="dismissErrorDialog()"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadInProgress: false,
      isReadOnlyUser: false,
      selectedFiles: [],
      overwriteFiles: [],
      currentRequest: {
        index: null,
        resolve: null,
        reject: null,
      },
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
  },
  methods: {
    selectFile(event) {
      this.selectedFiles = [];
      this.overwriteFiles = [];
      for (var file of event.target.files) {
        this.selectedFiles.push({
          name: file.name,
          size: file.size,
          errors: "",
          progress: 0,
          originalFile: file,
        });
      }
    },

    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },

    async uploadFiles() {
      this.selectedFiles.map((file) => {
        file.progress = 0;
      });
      setTimeout(async () => {
        /*
                    Wrapped in a timeout so the animation for resetting file
                    progress has enough time to complete!
                */
        this.uploadInProgress = true;
        for (let i = 0; i < this.selectedFiles.length; i++) {
          try {
            await this._upload(i, this.selectedFiles[i]);
          } catch (err) {
            continue;
          }
        }

        this.uploadInProgress = false;
      }, 500);
    },

    async _upload(index, file) {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("file", file.originalFile);

          await axios({
            method: "post",
            url: "/shirt_orders/bulk_pattern_upload/upload",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });

          this._reportFileProgress(index, file);
          resolve(true);
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            this.selectedFiles[index].errors = e.response.data.errors.file.join(
              "\n"
            );
            this.currentRequest = { index, resolve, reject };
            show_modal("#error-dialog");
          }
        }
      });
    },

    async _reportFileProgress(index, file) {
      if (file.hasOwnProperty("selectedFileIndex")) {
        this.selectedFiles[file.selectedFileIndex].progress = 100;
      } else {
        this.selectedFiles[index].progress = 100;
      }
    },

    dismissErrorDialog() {
      hide_modal("#error-dialog");
      this.currentRequest.reject();
    },

    _formatSizeUnits(bytes) {
      if (bytes >= 1048576) {
        bytes = (bytes / 1048576).toFixed(2) + " MB";
      } else if (bytes >= 1024) {
        bytes = (bytes / 1024).toFixed(2) + " KB";
      } else if (bytes > 1) {
        bytes = bytes + " bytes";
      } else if (bytes == 1) {
        bytes = bytes + " byte";
      } else {
        bytes = "0 bytes";
      }
      return bytes;
    },
  },
};
</script>
<style>
.progress {
  height: 25px;
  margin-bottom: 10px;
}

input[type="file"] {
  width: 100%;
  border: 0px;
}

.mb {
  margin-bottom: 20px;
}

.pb {
  display: block;
  padding-bottom: 10px;
}
</style>
